export default __webpack_public_path__ + "static/media/blob_top.65923468.svg";